module.exports = __webpack_public_path__ + "03_hair_silver.c0b27759.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/03_hair_silver.png
// module id = NPC6
// module chunks = 0